import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss']
})
export class RenameComponent implements OnInit {
  renameForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  id: any;
  url: string;
  projectID: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private toastrService: ToastrService,
  public dialogRef: MatDialogRef< RenameComponent>) { 
this.url=environment.baseUrl;
    //console.log(data.message);
    this.projectName = data.message.projectName;
    this.projectID = data.message.id;
    //console.log(this.projectID);
  }

  ngOnInit() {
    this.loadForm();
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  loadForm(){
    this.renameForm = this.formBuilder.group({
      rename:[],
      
    })
  }
  onRename(){
    this.submitted = true;
    if(this. renameForm.invalid){
      return;
    }
    var objFormval = this.renameForm.value;
 
    const ValueForRename={
      projectName:objFormval.rename,
      id:this.projectID,
    }
    if (! /^[a-zA-Z0-9]+$/.test(ValueForRename.projectName)) {
      this.toastrService.clear();
      this.toastrService.warning('Project Name is not Valid'); 
      return;
    }
    

this.http.put(this.url + '/HuLoopRest/huloop/project'   ,ValueForRename). subscribe((data) => {
  if(data) {
    // this.testCassedata= data;
      //console.log("projectData", data); 
       this.toastrService.success('Project renamed successfully'); 
     
      } 
 });
  }
}
